import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Analytics from 'analytics-opencare';

import { useAnalyticsService } from 'services/AnalyticsService';
import { useFunnelStorage } from 'pages/funnel/storage/Storage';
import { OptionBlock, Title } from 'pages/common/styled-components';
import { StepWrapper } from 'pages/funnel/styled-components';
import SingleSelect from 'pages/common/components/SingleSelect/SingleSelect';

import { generateStepAnalytics, STEP_KEY } from 'pages/funnel/utils';
import { getSpecialistData } from 'pages/funnel/specialtyFlow/funnelUtils';

import { FunnelStepPropTypes } from '../../common/types';

const analytics = new Analytics();

const HAS_REFERRAL_OPTIONS = [
  {
    id: 'yes',
    title: 'Yes',
    value: true,
  },
  {
    id: 'no',
    title: 'No',
    value: false,
  },
];

const HasSpecialistReferral = ({
  goToConfirmSubstep,
  position,
  moveToNextStep,
}) => {
  const storage = useFunnelStorage();
  const analyticsService = useAnalyticsService();

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_specialist-has-referral',
      ...generateStepAnalytics(position, storage),
      ...analyticsService.analyticsData,
    });
  }, []);

  const {
    specialist,
    specialistTitleWithIndefiniteArticle,
  } = getSpecialistData(storage);

  const submitAnswer = (selectedOption, index) => {
    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_specialist-referral',
      name: 'wizard',
      section: 'has-referral',
      ...generateStepAnalytics(index, storage, {
        response: selectedOption.id,
      }),
    });

    const shouldConfirmNoReferral =
      selectedOption.value === false && specialist.prefersReferral;

    storage.save(
      STEP_KEY.SPECIALIST_REFERRAL,
      {
        hasReferral: selectedOption.value,
      },
      !shouldConfirmNoReferral,
    );

    if (shouldConfirmNoReferral) {
      goToConfirmSubstep();
      return;
    }

    moveToNextStep();
  };

  return (
    <div>
      <Title id="title">
        Do you have a referral from a general dentist to see{' '}
        {specialistTitleWithIndefiniteArticle}?
      </Title>
      <StepWrapper>
        <form>
          <OptionBlock row={2}>
            {HAS_REFERRAL_OPTIONS.map((option, i) => (
              <SingleSelect
                name={option.id}
                key={option.id}
                id={option.id}
                title={option.title}
                describedBy="title"
                onChange={() => submitAnswer(option, i)}
              />
            ))}
          </OptionBlock>
        </form>
      </StepWrapper>
    </div>
  );
};

HasSpecialistReferral.propTypes = {
  ...FunnelStepPropTypes,
  goToConfirmSubstep: PropTypes.func.isRequired,
};

export { HasSpecialistReferral };
